import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import AddJob from './AddJob';
import AddJobStep2 from './AddJobStep2';

function AddJobWrapper() {
    const [job, setJob] = useState({
        jobtitle: '',
        description: '',
        postcode: '',
        budget: '',
        eta: '',
        servicesRequired: '',
    });

    return (
        <Routes>
            <Route path="/add-job-01" element={<AddJob job={job} setJob={setJob} />} />
            <Route path="/add-job-02" element={<AddJobStep2 job={job} setJob={setJob} />} />
        </Routes>
    );
}

export default AddJobWrapper;